import { useEffect, useState } from "react";
import api from "../../lib/api";

// The nine categories (labels editable by equipment:manage_all), read once per mounted screen.
export function useEquipmentCategories() {
  const [categories, setCategories] = useState([]);
  useEffect(() => {
    let alive = true;
    api.get("/equipment/categories").then(({ data }) => { if (alive) setCategories(data.items); }).catch(() => { if (alive) setCategories([]); });
    return () => { alive = false; };
  }, []);
  return categories;
}
